import { render, staticRenderFns } from "./AcompanhamentoDoCliente.vue?vue&type=template&id=e59ca5e2"
import script from "./AcompanhamentoDoCliente.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoDoCliente.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoDoCliente.vue?vue&type=style&index=0&id=e59ca5e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports